import { useCallback, useRef } from 'react';
import { Colorizer } from '@iot-app-kit/core-util';
import { bindStyleToDataStream } from '../utils/bindStylesToDataStreams';
import difference from 'lodash.difference';
const hasColor = (stream, styles) => {
    var _a;
    const streamHasColor = stream.color != null;
    const associatedStyles = stream.refId != null ? (_a = styles[stream.refId]) !== null && _a !== void 0 ? _a : {} : {};
    const hasAssociatedColor = associatedStyles.color != null;
    return streamHasColor || hasAssociatedColor;
};
export const useDataStreamStyler = (styles) => {
    const colorer = useRef(Colorizer());
    const colorMap = useRef({});
    const getColor = useCallback((id) => {
        if (id in colorMap.current) {
            return colorMap.current[id];
        }
        const color = colorer.current.next();
        colorMap.current[id] = color;
        return color;
    }, [colorMap, colorer]);
    const addColorAndStyles = useCallback((datastream) => {
        const styled = bindStyleToDataStream(styles)(datastream);
        // Only provide default if one is not already present in the data stream, and none is specified in the associated style settings.
        if (hasColor(styled, styles !== null && styles !== void 0 ? styles : {}))
            return styled;
        const color = getColor(styled.id);
        return {
            ...styled,
            color,
        };
    }, [styles, getColor]);
    const styleDatastreams = useCallback((datastreams) => {
        const activeStreams = datastreams.map(({ id }) => id);
        const colorMappedStreams = Object.keys(colorMap.current);
        const zombieColors = difference(colorMappedStreams, activeStreams);
        colorer.current.add(zombieColors);
        return datastreams.map(addColorAndStyles);
    }, [colorer, colorMap, addColorAndStyles]);
    return { styleDatastreams };
};
